/**
 * O par de campos "de / até" das toolbars dos miolos.
 *
 * Papel: desenha "<rótulo> de [data] até [data]", com os campos `type="date"` da
 * origem, e devolve o valor cru de cada um.
 *
 * Como usar: o componente devolve um fragmento, e não um contêiner, para que os
 * quatro elementos entrem na grade ou no `flex` da toolbar do módulo como
 * entram na origem — cada um como item da toolbar. A aparência do texto e dos
 * campos é do kit do módulo e entra por `classeDoRotulo` e `classeDoCampo`. O
 * valor guardado pela tela é o texto do campo; a regra de filtrar é
 * `dentroDoPeriodo`.
 */

interface FiltroDePeriodoProps {
  /** O que vem antes de "de", como a origem escreve: "Atualização", "Próx. visita". */
  rotulo: string;
  /** Valor do campo inicial, `''` ou `AAAA-MM-DD`. */
  de: string;
  /** Valor do campo final, `''` ou `AAAA-MM-DD`. */
  ate: string;
  /** Recebe o valor novo do campo inicial. */
  onMudarDe: (valor: string) => void;
  /** Recebe o valor novo do campo final. */
  onMudarAte: (valor: string) => void;
  /** Classes dos dois textos. */
  classeDoRotulo?: string;
  /** Classes dos dois campos. */
  classeDoCampo?: string;
}

/**
 * O filtro de período.
 *
 * @param rotulo - O texto antes de "de".
 * @param de - O valor do campo inicial.
 * @param ate - O valor do campo final.
 * @param onMudarDe - Chamado a cada mudança do campo inicial.
 * @param onMudarAte - Chamado a cada mudança do campo final.
 * @param classeDoRotulo - Classes dos textos, do kit do módulo.
 * @param classeDoCampo - Classes dos campos, do kit do módulo.
 * @returns Os quatro elementos, sem contêiner.
 */
export function FiltroDePeriodo({
  rotulo,
  de,
  ate,
  onMudarDe,
  onMudarAte,
  classeDoRotulo,
  classeDoCampo,
}: FiltroDePeriodoProps) {
  return (
    <>
      <span className={classeDoRotulo}>{rotulo} de</span>
      <input
        type="date"
        aria-label={`${rotulo} de`}
        value={de}
        onChange={(evento) => onMudarDe(evento.target.value)}
        className={classeDoCampo}
      />
      <span className={classeDoRotulo}>até</span>
      <input
        type="date"
        aria-label={`${rotulo} até`}
        value={ate}
        onChange={(evento) => onMudarAte(evento.target.value)}
        className={classeDoCampo}
      />
    </>
  );
}
